import React, { Component } from 'react';
import styled from 'styled-components'
import Header  from './../../Resources/AppScreens/CommonComponents/Workplace/Header.svg';
import Custom0  from './../../Resources/AppScreens/CommonComponents/Workplace/Office Map.svg';

import Custom1  from './../../Resources/AppScreens/CommonComponents/Workplace/Badge and Door Access.svg';
import Custom2  from './../../Resources/AppScreens/CommonComponents/Workplace/Two Buttons.svg';
import Custom3  from './../../Resources/AppScreens/CommonComponents/Workplace/Company News.svg';
//import { ReactComponent as Custom4 } from './../../Resources/AppScreens/CommonComponents/Hospitality/Property Resources.svg';
import Footer from './../../Resources/AppScreens/CommonComponents/Workplace/Bottom Navigation.svg';
import WorkplaceComponents from '../../Resources/AppScreens/Preview-Features/Workplace';

import {Container, ScrollableContent as _ScrollableContent} from './Common';

const ScrollableContent = styled(_ScrollableContent)`
    margin-top: 6px;
    &>* {
        margin-top: 5px;
    }
`;

const WorkplacePreview = ({ features }) => (<Container>
    <img src={Header} style={{width: "100%"} } />
    <ScrollableContent>
        <img src={Custom0} />
        <img src={Custom1} style={{marginTop: "4px"}} />
        <img src={Custom2} />
        <img src={Custom3} />
        {features && features.map(feature => WorkplaceComponents[feature])}
    </ScrollableContent>
    <img src={Footer} style={{ marginBottom: "0px;", marginTop: "auto", width: "100%" }} />
</Container>);

export default WorkplacePreview;

